import React, { Component } from 'react'
import styled from 'styled-components'
import Table from '../../components/Table'
import Modal from '../Modal'
import { pxToRem, color } from '../../utils'
import { connect } from 'react-redux'
import { reportActions } from '../../actions'
import { 
  Button
} from '../../components/Form'
import DownloadInvoice from '../../assets/icons/download.svg'

const WrapperInvoice = styled.div`
  display: flex;
  justify-content: center;
  img {
    position: absolute;
    margin: auto;
  }
`

const InvoiceButton = styled(Button)`
  background: url(${props => props.icon});
  border: none;
  background-repeat: no-repeat;
  background-position: center center;
  width: ${pxToRem(25)};
  height: ${pxToRem(25)};
  cursor: pointer;
`

class InvoiceModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false
    }
  }

  componentDidMount() {
  }

  componentWillReceiveProps(props) {
    this.setState(state => ({
      open: props.open,
      productId: props.productId,
      areaId: props.areaId
    }))
  }

  closeModal = () => {
    this.props.closeMethod()
  }

  render() {
    const columns = {
      batch: {
        label: 'Lote / Identificação',
        sortable: true,
        width: '50%'
      },
      url: {
        label: 'Visualizar',
        width: '50%',
        align: 'center',
        CellComponent: ({ product: column, row, ...rest }) => {
            return (
              <WrapperInvoice type={row.value}>
                <a href={row.url} target="_blank"><InvoiceButton icon={DownloadInvoice} alt={'Open Invoice'}/></a>
              </WrapperInvoice>
            )
        }
      }
    }

    const {
      name,
      open = false,
      size,
      title,
      productName,
      loading = false,
      closeMethod,
      invoiceList
    } = this.props

    return (
      <Modal
        title={`${title}: ${productName}`}
        name={name}
        open={open}
        size={size}
        loading={loading}
        closeMethod={closeMethod}
      >
        <Table
          data={(invoiceList || []).map(item => {
            return item
          })}
          columns={columns}
          width={1100}
          height={'45vh'}
          colSpan={2}
          defaultSort={{ key: 'batch', reverse: true }}
        />
      </Modal>
    )
  }
}

const mapStateToProps = state => ({
  currentUser: state.auth.userName,
  currentUserId: state.auth.userId,
  currentArea: state.auth.areaName,
  currentAreaId: state.auth.areaId,
  searchText: state.search.searchText,
  canChangeArea: state.auth.canChangeArea
})

const mapDispatchToProps = dispatch => {
}

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceModal)



// WEBPACK FOOTER //
// ./src/components/Inventory/InvoiceModal.js